import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReferenceDataConstants } from '../constants/reference-data-constants';
import { BaseUserSessionService } from './base-user-session.service';
import { ReferenceDataService } from './reference-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService extends BaseUserSessionService {
  protected userSessionDurationInMinutesConfig = ReferenceDataConstants.PrivateUserSessionDurationInMinutes;
  protected userSessionAboutToExpireDeltaInMinutesConfig =
    ReferenceDataConstants.PrivateUserSessionAboutToExpireDeltaInMinutes;

  constructor(referenceDataService: ReferenceDataService, httpClient: HttpClient) {
    super(referenceDataService, httpClient);
  }

  protected checkSession(): Observable<Object> {
    return this.httpClient.get('/SessionCheck/Check');
  }
}
